/* 
* Copyright (c) 2026 Send2Me, media capture and delivery platform. All rights reserved. 
* Distributed under the TruVideo proprietary license. 
*/
const statusConfig = {
  created: { label: 'Created', classes: 'badge badge-neutral text-neutral-content border-none' },
  opened: { label: 'Opened', classes: 'badge badge-info text-info-content font-bold' },
  in_progress: { label: 'In Progress', classes: 'badge badge-warning text-warning-content font-bold' },
  completed: { label: 'Completed', classes: 'badge badge-success text-success-content font-bold' },
  expired: { label: 'Expired', classes: 'badge badge-error text-error-content font-bold' },
  active: { label: 'Active', classes: 'badge badge-success text-success-content font-bold' },
  revoked: { label: 'Revoked', classes: 'badge badge-error text-error-content font-bold' },
  invited: { label: 'Invited', classes: 'badge badge-info text-info-content font-bold' },
  inactive: { label: 'Inactive', classes: 'badge badge-neutral text-neutral-content border-none' },
  open: { label: 'Open', classes: 'badge badge-info text-info-content font-bold' },
  closed: { label: 'Closed', classes: 'badge badge-neutral text-neutral-content border-none' },
  // Knowledge base document processing
  processed: { label: 'Processed', classes: 'badge badge-success text-success-content font-bold' },
  processing: { label: 'Processing', classes: 'badge badge-warning text-warning-content font-bold' },
  pending: { label: 'Pending', classes: 'badge badge-info text-info-content font-bold' },
  extracting: { label: 'Extracting', classes: 'badge badge-warning text-warning-content font-bold' },
  chunking: { label: 'Chunking', classes: 'badge badge-warning text-warning-content font-bold' },
  embedding: { label: 'Embedding', classes: 'badge badge-warning text-warning-content font-bold' },
  failed: { label: 'Failed', classes: 'badge badge-error text-error-content font-bold' },
  // AI agents
  live: { label: 'Live', classes: 'badge badge-success text-success-content font-bold' },
  not_live: { label: 'Not Live', classes: 'badge badge-neutral text-neutral-content border-none' }
};

const StatusBadge = ({ status }) => {
  const config = statusConfig[status] || { label: status, classes: 'badge badge-ghost' };

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.classes}`}>
      {config.label}
    </span>
  );
};

export default StatusBadge;
